import { emailRegExp } from 'constant/validations/emailValidation';

import {
  RefCodeSubmitType,
  SystemPreferencesFormType,
  SystemPreferencesType
} from 'types';

const numberRegExp = /^[0-9]+$/;

export const getNumberValidation = (value: string) => numberRegExp.test(value);

export const getValueKey = (value: string, clidFieldName = 'memberid') => {
  const isClientId = getNumberValidation(value);
  if (isClientId) {
    return clidFieldName;
  }
  return 'email';
};

export const hasNonEmptyValues = (
  values: Record<string, string>,
  excludeFields: string[] = []
) => {
  const requiredFields = Object.entries(values).filter(
    ([key]) => !excludeFields.includes(key)
  );
  return requiredFields.every(([, value]) => value !== '');
};

type NewFriend = {
  givname: string;
  surname: string;
  phoneOrEmail: string;
};

export const getEmailOrPhoneKey = ({
  givname,
  surname,
  phoneOrEmail
}: NewFriend): RefCodeSubmitType => {
  const isEmail = emailRegExp.test(phoneOrEmail);

  const phoneAndEmail: RefCodeSubmitType = {
    givname,
    surname,
    email: '',
    phone: ''
  };

  if (isEmail) {
    phoneAndEmail.email = phoneOrEmail;
  } else {
    phoneAndEmail.phone = phoneOrEmail;
  }

  return phoneAndEmail;
};

// eslint-disable-next-line
export const isDeepEqual = (x: any, y: any): boolean => {
  const ok = Object.keys;
  const tx = typeof x;
  const ty = typeof y;
  return x && y && tx === 'object' && tx === ty
    ? ok(x).length === ok(y).length &&
        ok(x).every((key) => isDeepEqual(x[key], y[key]))
    : x === y;
};

export const getFormByType = (
  form: SystemPreferencesFormType[],
  type: SystemPreferencesType
) => form.find((f) => f.trigger_type === type);
